var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F7D83",
    d: "M1.96 5.501a.8.8 0 0 0-.36.661v7.02c0 .673.573 1.218 1.28 1.218H5a1 1 0 0 0 1-1V9.53c0-.447.382-.81.853-.81h2.294c.47 0 .853.363.853.81v3.87a1 1 0 0 0 1 1h2.12c.707 0 1.28-.545 1.28-1.217v-7.02a.8.8 0 0 0-.359-.662L8.495 1.75a.89.89 0 0 0-.99 0L1.96 5.501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbIcon);
export default __webpack_public_path__ + "static/media/breadcrumb_icon.fa40472fa80e982c0cfa4d929ddd6731.svg";
export { ForwardRef as ReactComponent };